import { WarningCircle } from "@phosphor-icons/react";
import { motion } from "motion/react";
import { formatGermanDisplayText } from "../germanDisplay";

export function LoadingState({ rows = 6 }: { rows?: number }) {
  return <div className="skeleton-stack" aria-label="Daten werden geladen">{Array.from({ length: rows }, (_, index) => <div className="skeleton-row" key={index} />)}</div>;
}

export function EmptyState({ title = "Keine Einträge", detail = "Für die aktuellen Filter sind keine Daten vorhanden." }) {
  return <motion.div className="empty-state" initial={{ opacity: 0 }} animate={{ opacity: 1 }}><p className="empty-title">{title}</p><p>{detail}</p></motion.div>;
}

export function ErrorState({ error }: { error: unknown }) {
  return <div className="error-state" role="alert"><WarningCircle size={20} weight="fill" /><span>{error instanceof Error ? formatGermanDisplayText(error.message) : "Daten konnten nicht geladen werden."}</span></div>;
}
